'use strict';

/**
 * Represents different sections of thank you page (both for purchase and opt in pages)
 */
var THANKYOU_PAGE_SECTION_SLUGS = {
    CONFIRMATION: "Confirmation",
    REDIRECTION: "Redirection",
    UPSELL: "Upsell",
    TESTIMONIAL: "Testimonials",
    ANALYTICS: "Analytics",
};

exports.THANKYOU_PAGE_SECTION_SLUGS = THANKYOU_PAGE_SECTION_SLUGS;
//# sourceMappingURL=ThankYouPages.constants.js.map
